
import ContactUsSection from './contact-us-section'

export default function Terms({ onOpenContact }: { onOpenContact?: () => void }) {
	return (
		<div className="space-y-6">
			<h1 className="scroll-m-20 text-4xl font-bold tracking-tight">Terms of Service</h1>
			
			<p>Last updated: September 14, 2026</p>

			<h2>1. Acceptance of Terms</h2>
			<p>
				By accessing or using hangaround.live (the "Service"), you agree to be bound by these Terms of Service ("Terms"). 
				If you disagree with any part of the terms, you may not access the Service.
			</p>
			
			<h2>2. Age Restriction</h2>
			<p>
				The Service is intended for use by individuals who are at least 18 years old. 
				By using the Service, you represent and warrant that you are at least 18 years of age. 
				If you are under 18 years old, you may not, under any circumstances or for any reason, use the Service.
			</p>
			
			<h2>3. Description of Service</h2>
			<p>
				hangaround.live is a service that connects users with similar interests 
				and facilitates the formation of small private discussion groups.
			</p>

			<h2>4. User Conduct</h2>
			<p>You agree to use the Service in compliance with these Terms and applicable laws. You shall not:</p>
			<ul className="list-disc pl-4 mb-6">
				<li>Use the Service for any illegal purpose or in violation of any local, state, national, or international law</li>
				<li>Harass, abuse, or harm another person</li>
				<li>Impersonate or misrepresent your affiliation with any person or entity</li>
				<li>Interfere with or disrupt the Service or servers or networks connected to the Service</li>
				<li>Share sensitive personal information through the Service</li>
				<li>Attempt to gain access to the Service if you are under 18 years of age</li>
			</ul>

			<h2>5. Content</h2>
			<p>
				You are solely responsible for the content you provide through the Service. 
				We reserve the right to remove any content that violates these Terms or is otherwise objectionable.
			</p>
			
			<h2>6. Privacy</h2>
			<p>
				Your use of the Service is also governed by our Privacy Policy, which is incorporated into these Terms by reference.
			</p>
			
			<h2>7. Termination</h2>
			<p>
				We may terminate or suspend access to our Service immediately, without prior notice or liability, 
				for any reason whatsoever, including without limitation if you breach the Terms 
				or if we discover that you are under 18 years of age.
			</p>
			
			<h2>8. Limitation of Liability</h2>
			<p>
				In no event shall hangaround.live, nor its directors, employees, partners, agents, suppliers, or affiliates, 
				be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, 
				loss of profits, data, use, goodwill, or other intangible losses, 
				resulting from your access to or use of or inability to access or use the Service.
			</p>
			
			<h2>9. Changes</h2>
			<p>
				We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
				What constitutes a material change will be determined at our sole discretion.
			</p>
			<p>We will notify you of any changes by:</p>
			<ul className="list-disc pl-4 mb-6">
				<li>Posting the new Terms on this page</li>
				<li>Updating the "Last updated" date at the top of these Terms</li>
			</ul>
			<p>
				We encourage you to review these Terms periodically for any changes. 
				Changes to these Terms are effective when they are posted on this page.
			</p>
			
			<h2>10. Contact Us</h2>
			<ContactUsSection onOpenContact={onOpenContact} />


		</div>
	)
}
